module.exports = __webpack_public_path__ + "img/icon_upload.976659cb.svg";